import React from "react";
import { useLocation } from "react-router-dom";
import SEModuleSubtopic from "../SEModuleSubtopic";

const PlanningScopeWBS = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <SEModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Planning, Scope, WBS, Milestones, Deliverables"
      videos={[
        "https://www.youtube.com/embed/H6xT6bF4es0?si=H4UAhCcJr9ePsP8f",
        "https://www.youtube.com/embed/VlsobpC8GOY?si=jxgxMsY1N_3GP9P7",
        "https://www.youtube.com/embed/-T6JhbbBI7I?si=H_Sq66F-H7O3l3Jb",
        "https://www.youtube.com/embed/Ie8XEWjj5Rg?si=pJuomntfghZZHfz_"
      ]}
      takeaways={[]}
      questions={[
        "Catex, a medical healthcare private limited wanted to launch a telemedicine app to help patients in doctor consultation through online appointments, video consultation, health monitoring and telemedicine prescriptions. As an IT firm, think about the given scenario and create the phase-based and deliverable-based WBS. Find out the dependencies among the activities identified during WBS and prepare the suitable activity network.",
        "Draw the work breakdown structure for the online food delivery app by using process based with three levels.",
        "Given a project to develop an e-commerce website, identify three potential milestones and their corresponding deliverables.",
        "Assume that a university has contracted you to develop an online course registration system (OLCRS). (a) Define parallel work activities. (b) Establish milestones. (c) Represent tasks, durations and dependencies. (d) Develop a time-line chart for the OLCRS project.",
        "Your company is developing a new e-commerce platform for selling athletic wear. Develop a WBS for this e-commerce platform project showcasing at least five major components. Identify key milestones and deliverables mapped for each major component of the WBS."
      ]}
      exampleVideos={[]}
    />
  );
}

export default PlanningScopeWBS;
